import { View } from "react-native";
import { Text } from "react-native-paper";

import Button from "../../components/Button";
import type { ScreenProps } from ".";
import ScreenContainer from "../../components/ScreenContainer";
import ActionsContainer from "../../components/ActionsContainer";
import useIntercom from "../../hooks/useIntercom";
import { ScrollableContainer } from "../../components";

export default function OverviewScreen({ navigation }: ScreenProps<"Overview">) {
  function onContinue() {
    navigation.navigate("Terms");
  }

  function onGoBack() {
    navigation.getParent()?.navigate("DeferredComp");
  }

  useIntercom({ onFocus: { event: "viewed-enrollment-overview" } });

  return (
    <ScreenContainer navigationTitle="Enroll" goBack={onGoBack}>
      <ScrollableContainer containerClassName="px-7 py-9">
        <Text className="text-ink-darkest text-title-4 font-700">How to get started</Text>

        <Text className="mt-5 text-regular-normal font-400 text-ink-dark">
          Enrollment takes less than five (5) minutes to complete, and consists of the following steps:
        </Text>

        {["Terms & Conditions", "Account Details", "Confirmation"].map((step, i) => (
          <View key={i} className="flex-row items-center mt-4">
            <View className="items-center justify-center w-6 h-6 mr-3 border-2 rounded-full border-ink">
              <Text className="font-700 text-ink-dark">{i + 1}</Text>
            </View>

            <Text className="text-regular-normal font-700">{step}</Text>
          </View>
        ))}

        <View className="mt-8 border-t border-sky" />

        <Text className="mt-8 font-700 text-large-tight">What information will be needed?</Text>

        <Text className="mt-2 mb-5 text-regular-normal font-400 text-ink-dark">
          For financial purposes, enrollment requires the following information:
        </Text>

        {["Legal Name", "Mailing Address", "Social Security number"].map((info, i) => (
          <View key={i} className="flex-row items-start">
            <Text className="text-regular-normal font-400 mr-2">•</Text>
            <Text className="text-regular-normal font-400 text-ink-dark">{info}</Text>
          </View>
        ))}
      </ScrollableContainer>

      <ActionsContainer>
        <Button mode="contained" onPress={onContinue}>
          Continue
        </Button>
      </ActionsContainer>
    </ScreenContainer>
  );
}
